import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
export const GuaranteeSection: React.FC = () => {
  return <section className="py-20 px-4 bg-gray-50" data-id="element-90">
      <div className="max-w-5xl mx-auto" data-id="element-91">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 relative overflow-hidden" data-id="element-92">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-100 rounded-full blur-3xl opacity-30 -z-10" data-id="element-93"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-green-100 rounded-full blur-3xl opacity-30 -z-10" data-id="element-94"></div>

          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-95">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-96">
              <div className="relative" data-id="element-97">
                <div className="w-48 h-48 border-4 border-dashed border-blue-300 rounded-full animate-spin-slow flex items-center justify-center" data-id="element-98">
                  <div className="w-40 h-40 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center shadow-lg" data-id="element-99">
                    <div className="text-center text-white" data-id="element-100">
                      <ShieldCheckIcon className="w-16 h-16 mx-auto mb-2" data-id="element-101" />
                      <p className="font-black text-xl" data-id="element-102">30 DÍAS</p>
                      <p className="text-xs uppercase tracking-wider" data-id="element-103">
                        Garantía
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full md:w-2/3" data-id="element-104">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-105">
                Garantía de Satisfacción 100%
              </h2>

              <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-106">
                Si en los próximos 30 días sentís que el Megapack no te ayudó a
                mejorar tus entrenamientos, te devuelvo el 100% de tu dinero.
                Sin preguntas, sin vueltas.
              </p>

              <div className="space-y-3 mb-8" data-id="element-107">
                {['Sin riesgo para vos', 'Reembolso completo del 100%', 'Sin hacer preguntas', 'Proceso simple por email'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108">
                    <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-109" />
                    <span className="text-gray-700" data-id="element-110">{item}</span>
                  </div>)}
              </div>

              <button onClick={scrollToOffer} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-xl transition-colors shadow-lg" data-id="element-111">
                Probalo sin riesgo
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};